import { usePortalMenu as useInternalPortalMenu } from '@/hooks/usePortalMenu';

import type { ProcessedMenuGroup } from '@/utils/types';

interface UseSafeSessionReturn {
  getPortalMenu: () => Promise<ProcessedMenuGroup[]>;
}

export const usePortalMenu = (): UseSafeSessionReturn => {
  const { getPortalMenu } = useInternalPortalMenu();

  return {
    getPortalMenu,
  };
};
